import { UnknownString } from '../constants';
import { round } from './number';

export const formatRos = (val) => {
  if (val === false || val === undefined) return UnknownString;
  if (val >= 0 && val <= 1000) {
    return `${round(val, 2)} ch/hr`;
  }

  return UnknownString;
};

export default {
  formatRos,
};
